import { useQuery } from "@tanstack/react-query";
import { taskService } from "./task.services";
import { TASK_KEYS } from "./task.keys";
import { GetTaskParams } from "./task.types";

export const useGetTasks = (params: GetTaskParams) => {
  return useQuery({
    queryKey: TASK_KEYS.GET_TASKS(params),
    queryFn: () => taskService.getTasks(params),
  });
};

export const useGetTask = (taskId?: string) => {
  return useQuery({
    queryKey: TASK_KEYS.GET_TASK(taskId),
    queryFn: () => taskService.getTask(taskId ?? ""),
    enabled: !!taskId,
  });
};

export const useGetMostUrgentTasks = () => {
  return useQuery({
    queryKey: TASK_KEYS.GET_MOST_URGENT_TASKS(),
    queryFn: () => taskService.getMostUrgentTasks(),
  });
};
